import {
  List,
  ListItem,
  ListSubheader,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CoordinateSelector } from 'components/CoordinateSelector';
import { UserStatusChip } from 'components/UserStatusChip';
import { CoordinatesList } from 'features/geoEvents/components/CoordinatesList';
import { useReleaseFlag } from 'hooks/useReleaseFlags';
import { LatLng } from 'shared/types';
import { useAuthState } from 'state/useAuthState';

type InitialLocationListProps = {
  coordinates: LatLng;
  paywallSource: string;
};

export const InitialLocationList = (
  props: InitialLocationListProps,
): JSX.Element => {
  const { coordinates, paywallSource } = props;
  const { t } = useTranslation();
  const pinImprovements = useReleaseFlag('pin_drop_improvements');
  const { showMembershipFeatures } = useAuthState();

  if (!pinImprovements) {
    return (
      <CoordinatesList
        coordinates={coordinates}
        paywallSource={paywallSource}
      />
    );
  }

  return (
    <List
      subheader={
        <ListSubheader variant="watchduty-section-header">
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="h3">
              {t('geoEvent.structuredInfo.initialLocation')}
            </Typography>
            <UserStatusChip type="members" />
          </Stack>
        </ListSubheader>
      }
    >
      <ListItem disablePadding divider sx={{ display: 'block' }}>
        <CoordinateSelector
          coordinates={{ lat: coordinates.lat, lng: coordinates.lng }}
          blurred={!showMembershipFeatures}
          paywallSource={paywallSource}
        />
      </ListItem>
    </List>
  );
};
